/* unplugin-vue-components disabled */import { render } from "./EvmTip.vue?vue&type=template&id=39431584&scoped=true"
import script from "./EvmTip.vue?vue&type=script&lang=js"
export * from "./EvmTip.vue?vue&type=script&lang=js"

import "./EvmTip.vue?vue&type=style&index=0&id=39431584&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39431584"]])

export default __exports__